import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import LocationManagerProfileComp  from "./Component/LocationManagerProfileComp"

const LocationManagerProfile =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <LocationManagerProfileComp />
        </div>
        <Footer />
        </>
    )
}

export default LocationManagerProfile